
const states = [
    {
      state: 'Aguascalientes',
      cities: ['Aguascalientes', 'Calvillo', 'Jesús María', 'Rincón de Romos', 'San Francisco de los Romo', 'Tepezalá']
    },
    {
      state: 'Baja California',
      cities: ['Ensenada', 'Mexicali', 'Playas de Rosarito', 'Tecate', 'Tijuana']
    },
    {
      state: 'Baja California Sur',
      cities: ['Cabo San Lucas', 'Ciudad Constitución', 'La Paz', 'Loreto', 'San José del Cabo']
    },
    {
      state: 'Campeche',
      cities: ['Campeche', 'Calkiní', 'Ciudad del Carmen', 'Escárcega', 'Hecelchakán']
    },
    {
      state: 'Coahuila',
      cities: ['Acuña', 'Arteaga', 'Francisco I. Madero', 'Monclova', 'Piedras Negras', 'Saltillo', 'Torreón']
    },
    {
      state: 'Colima',
      cities: ['Colima', 'Manzanillo', 'Tecomán', 'Villa de Álvarez']
    },
    {
      state: 'Chiapas',
      cities: ['Comitán', 'Palenque', 'San Cristóbal de las Casas', 'Tapachula', 'Tuxtla Gutiérrez']
    },
    {
      state: 'Chihuahua',
      cities: ['Chihuahua', 'Ciudad Juárez', 'Cuauhtémoc', 'Delicias', 'Hidalgo del Parral']
    },
    {
      state: 'Ciudad de México',
      cities: ['Ciudad de México']
    },
    {
      state: 'Durango',
      cities: ['Durango', 'Gómez Palacio', 'Lerdo', 'Nuevo Ideal', 'Peñón Blanco', 'Pueblo Nuevo']
    },
    {
      state: 'Guanajuato',
      cities: ['Celaya', 'Irapuato', 'León', 'Salamanca', 'San Francisco del Rincón', 'Silao']
    },
    {
      state: 'Guerrero',
      cities: ['Acapulco', 'Chilapa', 'Iguala', 'Taxco', 'Zihuatanejo']
    },
    {
      state: 'Hidalgo',
      cities: ['Huejutla', 'Pachuca', 'Tula', 'Tulancingo', 'Zimapán']
    },
    {
      state: 'Jalisco',
      cities: ['Guadalajara', 'Puerto Vallarta', 'Tlaquepaque', 'Tonalá', 'Zapopan']
    },
    {
      state: 'México',
      cities: ['Atlacomulco', 'Ecatepec', 'Naucalpan', 'Toluca', 'Tultepec', 'Tultitlán']
    },
    {
      state: 'Michoacán',
      cities: ['Lázaro Cárdenas', 'Morelia', 'Pátzcuaro', 'Uruapan', 'Zamora']
    },
    {
      state: 'Morelos',
      cities: ['Cuautla', 'Cuernavaca', 'Jiutepec', 'Temixco', 'Yautepec']
    },
    {
      state: 'Nayarit',
      cities: ['Compostela', 'Tepic', 'Tuxpan', 'Xalisco']
    },
    {
      state: 'Nuevo León',
      cities: ['Apodaca', 'Guadalupe', 'Monterrey', 'San Nicolás de los Garza', 'Santa Catarina']
    },
    {
      state: 'Oaxaca',
      cities: ['Juchitán', 'Oaxaca', 'Salina Cruz', 'Santa Lucía del Camino', 'Santo Domingo Tehuantepec']
    },
    {
      state: 'Puebla',
      cities: ['Puebla', 'San Andrés Cholula', 'San Martín Texmelucan', 'Tehuacán', 'Zacatlán']
    },
    {
      state: 'Querétaro',
      cities: ['Corregidora', 'El Marqués', 'Querétaro', 'San Juan del Río', 'Tequisquiapan']
    },
    {
      state: 'Quintana Roo',
      cities: ['Cancún', 'Chetumal', 'Cozumel', 'Playa del Carmen', 'Tulum']
    },
    {
      state: 'San Luis Potosí',
      cities: ['Ciudad Valles', 'Matehuala', 'San Luis Potosí', 'Soledad de Graciano Sánchez', 'Tamazunchale']
    },
    {
      state: 'Sinaloa',
      cities: ['Culiacán', 'Guasave', 'Los Mochis', 'Mazatlán', 'Navolato']
    },
    {
      state: 'Sonora',
      cities: ['Caborca', 'Ciudad Obregón', 'Guaymas', 'Hermosillo', 'Navojoa']
    },
    {
      state: 'Tabasco',
      cities: ['Comalcalco', 'Cárdenas', 'Villahermosa']
    },
    {
      state: 'Tamaulipas',
      cities: ['Ciudad Madero', 'Matamoros', 'Nuevo Laredo', 'Reynosa', 'Tampico']
    },
    {
      state: 'Tlaxcala',
      cities: ['Apizaco', 'Huamantla', 'Tlaxcala']
    },
    {
      state: 'Veracruz',
      cities: ['Boca del Río', 'Coatzacoalcos', 'Orizaba', 'Veracruz', 'Xalapa']
    },
    {
      state: 'Yucatán',
      cities: ['Mérida', 'Progreso', 'Ticul', 'Tizimín', 'Valladolid']
    },
    {
      state: 'Zacatecas',
      cities: ['Fresnillo', 'Guadalupe', 'Jerez', 'Zacatecas']
    }
]

const searchStates = async (filters: Record<string, any> = {}) => {
  return states.map((s:any)=>{return{state:s.state}})
};

const searchCitiesByState = async (filters: Record<string, any> = {}) => {
  const stateFilter =
    filters.state ||
    filters['filter[state]'] ||
    ''; // Puede venir por state o filter[state]
  const cityFilter =
    filters.city ||
    filters['filter[city]'] ||
    ''; // Puede venir por city o filter[city]

  // Si no hay state seleccionado, regresa vacío:
  if (!stateFilter) return [];

  // Encuentra el estado:
  const stateObj = states.find(
    (s:any) => s.state.toLowerCase() === stateFilter.toLowerCase()
  );
  if (!stateObj) return [];

  // Si hay filtro de ciudad, filtra también las ciudades:
  let cities = stateObj.cities;
  if (cityFilter && cityFilter.length > 0) {
    cities = cities.filter((c: string) =>
      c.toLowerCase().includes(cityFilter.toLowerCase())
    );
  }

  return cities.map((city: string) => ({ city }));
};

export default {
  searchStates,
  searchCitiesByState,
};
